import * as React from "react";
import Header from "components/Header";
import { User } from "modules/auth/User";
import MenuLink from "components/Header/MenuLink";

type SearchScreenHeaderProps = {
  hideProfileMenu?: boolean;
  onLogin: () => any;
  onLogout: () => any;
  onNavigateHome: () => any;
  onPartnerChange?: () => void;
  profileLinks: MenuLink[];
  mainNavigationLinks?: MenuLink[];
  selectedPartnerLabel?: string;
  user: User | null;
};

const SearchScreenHeader = ({
  onLogin,
  onLogout,
  onNavigateHome,
  onPartnerChange,
  profileLinks,
  mainNavigationLinks,
  selectedPartnerLabel,
  user,
}: SearchScreenHeaderProps) => {
  return (
    <Header
      mainNavigationLinks={mainNavigationLinks || []}
      onLogin={onLogin}
      onLogoClicked={onNavigateHome}
      onLogout={onLogout}
      onPartnerChange={onPartnerChange}
      profileMenuLinks={profileLinks}
      selectedPartnerLabel={selectedPartnerLabel}
      user={user}
    />
  );
};

export default SearchScreenHeader;
